import { formatCurrency } from '@kk/shared/utils/numbers';
import type { CellContext } from '@tanstack/table-core';

export function getRowYearClassName(
  dateString: string,
  firstYear: number | null,
) {
  if (!dateString) return '';
  if (!firstYear) throw new Error('Missing firstYear');

  // the first year is used to determine the starting point of odd/even, since the first set of rows should always be 'bg-inherit' (white)
  const isFirstYearEven = firstYear % 2 === 0;
  const year = new Date(dateString).getFullYear();
  const isEven = year % 2 === 0;

  // Determine the background class based on the parity of the first year and the extracted year
  // If the first year is even, assign 'bg-neutral-5' for odd years, and 'bg-inherit' for even years.
  // If the first year is odd, assign 'bg-neutral-5' for even years, and 'bg-inherit' for odd years.
  return isFirstYearEven === isEven ? 'bg-inherit' : 'bg-neutral-5';
}

export interface FormatCellCurrencyOptions {
  hideFirstRow?: boolean;
  emptyCellString?: string;
  valueOverride?: number;
}

export function formatCellCurrency<TRow>(
  info: CellContext<TRow, number | undefined | null>,
  options?: FormatCellCurrencyOptions,
) {
  const value = options?.valueOverride ?? info.getValue();

  if (options?.hideFirstRow && info.row.index === 0) {
    return '';
  }
  if (value === undefined) {
    return options?.emptyCellString || '';
  }

  return formatCurrency(value, {
    showZero: true,
    appendCurrency: false,
  });
}
